import { ColTypeDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { LabelCellRenderer } from 'routes/secondary-market-batch/grid/components/label-cell-renderer';
import { RowData } from 'state/workspaces/secondary-market/batch/model';

export function useLargeTextColumnType(): ColTypeDef<RowData, RowData[keyof RowData]> {
  return useMemo(
    () => ({
      cellEditor: 'agLargeTextCellEditor',
      cellEditorPopup: true,
      filter: 'agTextColumnFilter',
      filterParams: {
        filterOptions: ['contains', 'notContains'],
      },
      cellEditorParams: {},
      cellRenderer: LabelCellRenderer,
    }),
    [],
  );
}
